<template>
  <div class="wrap">
    <!-- $ 侧边栏导航 模块 -->
    <div class="aside">
      <el-menu
        :default-active="'/management/managementData'"
        text-color="#45474D"
        active-text-color="#FE2C55"
        router
      >
        <div v-for="(item, index) in navList" :key="index">
          <!-- 单层 -->
          <el-menu-item
            v-if="item.children.length == 0"
            :index="item.path"
            route
          >
            <div>
              <i :class="['iconfont', [ item.icon ]]" style="fontSize:20px;marginRight:10px;"></i>
              <span slot="title">{{ item.title }}</span>
            </div>
          </el-menu-item>
        </div>
      </el-menu>
    </div>
    <!-- 占位 -->
    <div class="left"></div>

    <!-- $ 主体 模块 -->
    <div class="main">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navList: [],
    };
  },
  watch:{
    '$route'(newval,oldval){
      // watch 路由变化
      // console.log(newval,oldval)
    }
  },
  mounted() {
    let routerList = this.$router.options.routes;
    let workList = [];
    routerList.forEach((item) => {
      // 解析当前路由下所有路径，用于渲染侧边导航
      if (item.name == "management") {
        workList = item.children;
      }
    });
    workList.forEach((item) => {
      let children = [];
      // 如果有子路由
      if (item.children) {
        item.children.forEach((child) => {
          children.push({
            path: child.path,
            title: child.meta.title,
          });
        });
      }
      this.navList.push({
        path: item.path,
        title: item.meta.title,
        children: children,
        icon: item.icon
      });
    });
    console.log('当前页面路由--', this.navList);
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  display: flex;
  // height: 100vh;
}
// $ 侧边栏导航 模块
.aside {
  width: 204px;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
  position: fixed;
  top: 56px;
  left: 0;
}
.left {
  width: 204px;
  height: 100%;
}
// $ 主体 模块
.main {
  flex: 1;
  height: 100%;
  background-color: #f1f1f1;
  padding: 8px;
  overflow: hidden;
}

/deep/.el-menu {
  border: none;
  width: 200px;
  margin: 0 auto;
}
// 选中的背景颜色
/deep/.el-menu-item.is-active {
  background: #fcebee;
  border-radius: 6px !important;
}
// 鼠标悬浮效果
/deep/.el-submenu__title:hover {
  outline: 0 !important;
  background: rgba(252, 235, 238, 0.5) !important;
  border-radius: 6px !important;
}
.el-menu-item:hover {
  outline: 0 !important;
  background: rgba(252, 235, 238, 0.5) !important;
  border-radius: 6px !important;
}
</style>